var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilotMicrosoftAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.076 1.637a.103.103 0 0 0-.09.05L.014 11.95a.102.102 0 0 0 0 .104l6.039 10.26c.04.068.14.068.18 0l5.972-10.262a.102.102 0 0 0-.002-.104L6.166 1.687a.103.103 0 0 0-.09-.05zm2.863 0a.103.103 0 0 0-.09.154l5.186 8.967a.105.105 0 0 0 .09.053h3.117c.08 0 .13-.088.09-.157l-5.186-8.966a.104.104 0 0 0-.09-.051H8.94zm5.891 0a.102.102 0 0 0-.088.154L20.656 12l-5.914 10.209a.102.102 0 0 0 .088.154h3.123a.1.1 0 0 0 .088-.05l5.945-10.262a.1.1 0 0 0 0-.102L18.041 1.688a.1.1 0 0 0-.088-.051H14.83zm-.79 11.7a.1.1 0 0 0-.089.052l-5.101 8.82c-.04.069.01.154.09.154h3.117a.104.104 0 0 0 .09-.05l5.1-8.82a.103.103 0 0 0-.09-.155h-3.118z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotMicrosoftAzure);
export default __webpack_public_path__ + "static/media/copilot-microsoft-azure.4430ecc9c9eb0144b6a48d26ad03e632.svg";
export { ForwardRef as ReactComponent };